import { Spine } from "pixi-spine";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { FillingPotParams } from "./FillinPotParams";
import { MultiBonusType, SlotGameBet } from "../../api";
import { IFillingPotIncrements } from "./IFillingPotIncrement";
import * as PIXI from 'pixi.js';
import { ITrack } from "../../AudioManager";
import { IIncrementSavePerBet } from "./ILevelsPerBetSaved";
import { PlaceHolderMutiPotConfig } from "./FillingPotGeneric";
import { PotCollectPosition } from "./CollectSRAPathFillingPot";

export interface ISpineTrackAnimation {
    loopAnimation: boolean,
    trackAnimationIndex: number,
    soundTrack : ITrack,
    duration : number,
    animationName : string,
    isActive : boolean,
}

export abstract class IGenericFamilySpine implements Resourceful  {
    protected gameName : string = null;
    protected familyType : string = null;
    protected params : FillingPotParams = null;
    protected spineTrackMap : Map<string,ITrack> = new Map<string,ITrack>();
    constructor(params: FillingPotParams){
        this.params = params;
    }
    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {
        //throw new Error("Method not implemented.");
    }
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
    {
        //throw new Error("Method not implemented.");
    }

    public abstract AddTrack(track: ITrack, nameTrack : string );
    public abstract CreateAnimFamilyFeature(spineHit: Spine , app: PIXI.Application<HTMLCanvasElement>  , placeHolderMutiPotConfig: Partial<PlaceHolderMutiPotConfig>) : void;
    public abstract StartIncrement(incrementsParams: IFillingPotIncrements): void;
    public abstract ReelStops(winSymbolsReelStop : string[]): void;
    public abstract StopAnim(): void;
    public abstract RestartAnim(): void;
    public abstract Update(): void;   
    public abstract SetBet(selectedBet: SlotGameBet);
    public abstract StartBonusWin(bonusName:string , bonusVariantName? : MultiBonusType[] , multiplier?: number);
    public abstract StartAnticipationBegin();
    public abstract EndAnticipationBegin();
    public abstract LevelDebuggerTest(levelTestit: number, potIndex? : number);   
    public abstract PathDebuggerTest(command : string);   
    public abstract OnStartBigWinShow();
    public abstract OnEndBigWinShow();
    public abstract UpdateSpin();
    public abstract SaveCurrentIncrement();
    public abstract Destroy();
    public abstract ViewPixiAPP(): PIXI.Container;
    public abstract FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay : RegExpMatchArray);
    public abstract GetCurrentLevels() : IIncrementSavePerBet;
    public abstract SetCurrentFromBaseGameLevels(incrementSavePerBet : IIncrementSavePerBet);
    public abstract ParticlesDebugger();
    protected AddQueueAnimation(nameAnimation: string, trackAnimationIndex: number, loopAnim = false, delay: number = 0 , spine : Spine) {
        spine?.state?.addAnimation(trackAnimationIndex, nameAnimation, loopAnim, delay);
    }
    public abstract RamclearFillingPot(selecteBet: SlotGameBet);

    public ClearCache(spineInstance: Spine) {
         // También intentamos liberar texturas desde `spineInstance.textures`
        spineInstance.skeleton.setToSetupPose();
        spineInstance.spineData = null;
        spineInstance.skeleton = null;
        spineInstance.state = null;
        spineInstance.slotContainers = null;
        //spineInstance.destroy({ children: true, texture: true, baseTexture: true });
    }

    public UpdateTargetsGlobal(potCollectPosition: PotCollectPosition [])
    {
    }
    public OnResize(): void {
        
    }
}